import React, { useEffect } from "react";
import useForm from '../../../hooks/useForm';
import { FormField } from '@prosolve/common-components-ui'

export default ({
  reportConfig = {},
  isReadOnly,
  onChange
}) => {
  const formSchema = {
    optionalFields: ['hideQuestFields', 'hideIdFields', 'hasApprovals'],
    initData: { ...reportConfig }
  }

  const formData = useForm(formSchema)

  useEffect(() => {
    onChange(formData.values)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
    }}>
      <FormField
        fieldId='hideQuestFields'
        type='checkbox'
        label='Hide Quest Fields'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='hideIdFields'
        type='checkbox'
        label='Hide Id Fields'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
      <FormField
        fieldId='hasApprovals'
        type='checkbox'
        label='Has Approvals'
        disabled={isReadOnly}
        style={{ flex: 1 }}
        formData={formData}
      />
    </div>
  )
}